import { QcDocument } from '../../domain/entities/quality-control-document.entity';
import { QualityControlDocumentType, QualityControlDocumentTypeLabel } from '../../domain/value-objects/quality-control-document-type.vo';
import { DocumentOrigin } from '../../domain/value-objects/document-origin.vo';

export interface QcDocumentApiResponse {
  id: string;
  qualityControlId: string;
  filename: string;
  filePath: string;
  documentType: number;
  extension: string;
  size: number;
  version: number;
  documentOrigin: number;
  createdAt: string;
}

export interface QcDocumentListPagedApiResponse {
  items: QcDocumentApiResponse[];
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalItemsCount: number;
}

export class QcDocumentMapper {
  static toDomain(raw: QcDocumentApiResponse): QcDocument {
    return {
      id: raw.id,
      qualityControlId: raw.qualityControlId,
      filename: raw.filename,
      filePath: raw.filePath,
      documentType: raw.documentType as QualityControlDocumentType,
      extension: raw.extension,
      size: raw.size,
      version: raw.version,
      documentOrigin: raw.documentOrigin as DocumentOrigin,
      createdAt: new Date(raw.createdAt),
    };
  }

  static toDomainList(rawList: QcDocumentApiResponse[]): QcDocument[] {
    return rawList.map((raw) => this.toDomain(raw));
  }

  static formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 B';
    if (bytes < 1024) return `${bytes.toFixed(2)} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  }

  static toDocumentTypeLabel(type: QualityControlDocumentType): string {
    return QualityControlDocumentTypeLabel[type] ?? String(type);
  }
}
